$('document').ready(function () {
	// Page Loader
	$('.page-loader').fadeOut();

	function adjustHeight(element, newHeight) {
		var counter = 1;
		setInterval(function () {
			if (counter <= newHeight) {
				element.css("height", counter);
				counter++;
			}
		}, 0.1);
	}

	$(".mobile-menu-button").click(function () {
		$(".mobile-menu").slideToggle();
		$(this).toggleClass("active");
		$('body').toggleClass("mobile-menu-active");
	});

	$('.mobile-menu ul li.menu-item-has-children > a').click(function (event) {
		if ($(this).parent().hasClass('active')) {
			$(this).parent().removeClass('active');
		} else {
			$(this).parent().addClass('active');
			event.preventDefault();
		}
	});


	// Function to check if screen size is LG or above (992 pixels or wider)
	function isLgScreen() {
		return $(window).width() >= 992;
	}

	// Function to show/hide content based on screen size
	function updateContentVisibility() {
		if (isLgScreen()) {
			// Desktop
			$('body').removeClass('mobile-active').addClass('desktop-active');

			$('.desktop-active .header .menu-item-has-children').mouseenter(function (e) {
				e.preventDefault();
				$(this).addClass('menu-active');

				// Calculate the height of the parent div with 30px added
				var newHeight = $(this).find('.sub-menu').outerHeight() + 30;
				$(this).css('height', newHeight);
			});

			$('.desktop-active .header .menu-item-has-children').mouseleave(function () {
				// Reset the height of the parent div when hovering out, only if no submenu item is focused
				if (!$(this).find('.sub-menu :focus').length) {
					$(this).css('height', 'auto');
					$(this).removeClass('menu-active');
				}
			});

			// Focus on the <a> tag
			$('.desktop-active .header .menu-item-has-children > a').focus(function (e) {
				e.preventDefault();
				var parent = $(this).parent();
				parent.addClass('menu-active');

				var newHeight = parent.find('.sub-menu').outerHeight() + 30;
				parent.css('height', newHeight);
			});

			// Keep menu active when focusing on submenu items
			$('.desktop-active .header .menu-item-has-children .sub-menu li a').focus(function (e) {
				e.stopPropagation(); // Prevent focus from going back to the parent
				var parent = $(this).closest('.menu-item-has-children');
				parent.addClass('menu-active');

				// Ensure the height stays while focusing on submenu items
				var newHeight = parent.find('.sub-menu').outerHeight() + 30;
				parent.css('height', newHeight);
			});

			// Reset on blur of sub-menu items only if no submenu item is focused
			$('.desktop-active .header .menu-item-has-children .sub-menu li a').blur(function () {
				var parent = $(this).closest('.menu-item-has-children');
				// Check if any submenu item is focused
				if (!parent.find('.sub-menu :focus').length) {
					parent.css('height', 'auto');
					parent.removeClass('menu-active');
				}
			});

			// Reset on blur of the parent <a> tag only if no submenu item is focused
			$('.desktop-active .header .menu-item-has-children > a').blur(function () {
				var parent = $(this).parent();
				// Check if any submenu item is focused
				if (!parent.find('.sub-menu :focus').length) {
					parent.css('height', 'auto');
					parent.removeClass('menu-active');
				}
			});

		} else {
			// Mobile
			$('body').removeClass('desktop-active').addClass('mobile-active');

			$('.mobile-active .header .menu-item-has-children a').focus(function (e) {
				e.stopPropagation(); // Prevent focus from going back to the parent
				$(this).parent().addClass('menu-active');
				$(this).parent().addClass('active');
			});

		}

	}

	// Initial check on document ready
	updateContentVisibility();

	// Update on window resize
	$(window).resize(function () {
		updateContentVisibility();
	});

	// Header sticky
	var scroll = $(window).scrollTop();
	if (scroll >= 50) {
		$(".header").addClass("sticky");
	} else {
		$(".header").removeClass("sticky");
	}


	$('.accordion-row h3 a').click(function (e) {
		e.preventDefault();
		if ($(this).parent().parent().hasClass('active')) {
			$(this).parent().parent().removeClass('active');
		} else {
			$('.accordion-row').removeClass('active');
			$(this).parent().parent().addClass('active');
		}
	});

	function encodeSearchInput() {
		// Select the input fields by their IDs
		var searchInputDesktop = document.getElementById('s');
		var searchInputMobile = document.getElementById('search-mobile');

		// Encode the input values
		if (searchInputDesktop) {
			searchInputDesktop.value = encodeURIComponent(searchInputDesktop.value);
		}

		if (searchInputMobile) {
			searchInputMobile.value = encodeURIComponent(searchInputMobile.value);
		}
	}

	// Add an event listener to the form submission
	var forms = document.querySelectorAll('.search-form'); // Select all forms with the class

	forms.forEach(function (form) {
		var forms = document.querySelectorAll('.search-form');

		forms.forEach(function (form) {
			form.addEventListener('submit', function (event) {
				encodeSearchInput(); // Call the encoding function
				form.submit(); // Submit the form after encoding
			});
		});
	});

	// Filter menus 
	/*
	$('.filter-menu').on('click', function (event) {
		if ($(this).hasClass('active')) {
			$('.filter-menu').removeClass('active');
		} else {
			$('.filter-menu').removeClass('active');
			$(this).addClass('active');
		}

		event.stopPropagation();
	});
	*/

	// Focus for screenreaders
	$('.filter-menu button').on('focus', function (event) {
		$('.filter-menu').removeClass('active');
		$(this).parent('.filter-menu').addClass('active');

		// Focus on the first list item
		$(this).siblings('ul').find('li').first().focus();

		event.stopPropagation();
	});

	// Handle keyboard navigation within the list items
	$('.filter-menu ul li').on('focus', function () {
		$(this).parent().closest('.filter-menu').addClass('active'); // Keep the menu active
	});

	// Optionally, handle the blur event to deactivate the menu
	$('.filter-menu ul li').on('blur', function () {
		$(this).closest('.filter-menu').removeClass('active');
	});


	// Hide filter dropdown when clicking outside
	$(document).on('click', function (event) {
		if (!$(event.target).closest('.filter-menu').length) {
			$('.filter-menu').removeClass('active');
			$('.filter-menu button').removeClass('active');
			$('.filter-menu ul li a').removeClass('active');

		}
	});

	// Update button filter text when clicking on an li item
	$('.filter-menu ul li a, .filter-menu .filter-btn').on('click', function (event) {
		event.preventDefault();
		$('.filter-menu button').removeClass('active');
		$('.filter-menu ul li a').removeClass('active');
		$(this).closest('.filter-menu').find('button').addClass('active');
		$(this).addClass('active');
		if ($(this).data('query')) {

			// Refresh page with filter query string
			var target = $(this).data('target');
			var filterPage = window.location.origin + '/' + target;
			var dataQuery = $(this).data('query');
			window.location.href = filterPage + dataQuery;

		} else {

			// Filter
			var filter_slug = $(this).data('target');

			$('.accordion-row').hide();

			//Show active filter
			$('.active-filters').remove();

			const $activeFiltersDiv = $('<div class="active-filters mb-4 w-100 d-inline-block"></div>');
			const $filterTitle = $('<strong class="d-block d-md-inline-block mb-3 mb-lg-0">Active filters: </strong>');
			$('.filter-menu-target').append($activeFiltersDiv);
			$activeFiltersDiv.append($filterTitle);

			const displayValue = filter_slug.replace(/-/g, ' ');

			const $filterLink = $('<a></a>')
				.attr('href', '#')
				.attr('title', 'Remove ' + displayValue + ' filter')
				.text(displayValue)
				.addClass('filter-reload');

			$activeFiltersDiv.append($filterLink).append(' ');

			// Show .accordion-row elements that have classes matching the text
			var matchingRows = $('.accordion-row .' + filter_slug).closest('.accordion-row');
			if (matchingRows.length > 0) {
				matchingRows.show();
				$('.notice-block').hide();

			} else {
				$('.notice-block').show();
			}


			// Also do a check to see if within an accordion-block all accordion-rows are display none. if true set header to display none;
			$('.accordion-block').each(function () {
				var $accordionBlock = $(this);
				var $rows = $accordionBlock.find('.accordion-row');

				// Check if all rows are hidden
				var allHidden = $rows.filter(':visible').length === 0;

				// Find the <strong> element preceding the .accordion-block
				var $strong = $accordionBlock.prevAll('strong').first();

				if (allHidden) {
					$strong.hide();
				} else {
					$strong.show();
				}
			});
		}
	});

	// Function to get query string parameters
	function getQueryParams() {
		var params = {};
		var queryString = window.location.search.substring(1);
		var queries = queryString.split("&");
		for (var i = 0; i < queries.length; i++) {
			var pair = queries[i].split("=");
			if (pair[0]) {
				params[pair[0]] = decodeURIComponent(pair[1] || '');
			}
		}
		return params;
	}

	// Sanitize input to prevent XSS
	function sanitize(input) {
		return $('<div>').text(input).html(); // Converts to HTML-safe string
	}

	$(document).on('click', '.active-filters a', function (event) {
		event.preventDefault(); // Prevent the default link behavior

		if ($(this).hasClass('filter-reload')) {
			window.location.reload();
		} else {
			if (window.location.search) {
				// Remove the query string
				var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
				// Redirect to the new URL
				window.location.href = newUrl;
			}
		}


	});

	// Get all query parameters
	const queryParams = getQueryParams();
	const $activeFiltersDiv = $('<div class="active-filters mb-4 w-100 d-inline-block"></div>');

	// Add the title to the active filters div
	const $filterTitle = $('<strong class="d-block d-md-inline-block mb-3 mb-lg-0">Active filters: </strong>');

	if (window.location.search) {

		if (queryParams.public_engagement === 'true') {
			delete queryParams.public_engagement;
		} else {
			$activeFiltersDiv.append($filterTitle);
		}
	}

	// Iterate over query parameters
	for (const [key, value] of Object.entries(queryParams)) {
		if (value) { // Ensure value is not empty
			const sanitizedValue = sanitize(value);
			// Replace hyphens with spaces for display and title
			const displayValue = sanitizedValue.replace(/-/g, ' ');

			const $filterLink = $('<a></a>')
				.attr('href', '#')
				.attr('title', 'Remove ' + displayValue + ' filter')
				.text(displayValue);

			$activeFiltersDiv.append($filterLink).append(' '); // Add a space between filters
		}
	}

	// Append the active filters div to .filters if it has any filters
	if ($activeFiltersDiv.children().length > 0) {
		$('.filter-menus').append($activeFiltersDiv);
	}

	// Get the query parameters
	var fullQuery = window.location.search;

	var filters = {
		programmes_filter: { text: 'Programmes' },
		platforms_filter: { text: 'Platforms and services' },
		research_filter: { text: 'Research and expertise' },
		public_engagement: { text: 'Public engagement' },
		research: { text: 'Research and expertise' }
	};

	// Loop through the mapping and apply the 'active' class if the query parameter exists
	$.each(filters, function (param, target) {
		if (queryParams[param]) {
			$('.filter-menu button').filter(function () {
				return $(this).text().trim() === target.text;
			}).addClass('active');
		}
	});

	$('.filter-menu li a').on('click', function (event) {
		// Prevent the default action of the link
		event.preventDefault();

		// Your existing logic
		$(this).filter(function () {
			return $(this).data('query') === fullQuery;
		}).addClass('active');
	});

	// Click event for the reset button
	$('#reset-button').on('click', function (e) {
		e.preventDefault();
		$('.accordion-row').show(); // Show all .accordion-row elements
		$('.notice-block').hide(); // Hide the error notice
	});

	// Team popup
	$('.modal-overlay, .close-popup-js').on('click', function () {
		$('.popup').removeClass('active');
		$('.team-block-col > a, .team-slider-js a').removeClass('active');
		$('.popup').find('.team-name').html('');
		$('.popup').find('.team-jobtitle').html('');
		$('.popup').find('.team-img').css('background-image', '');
		$('.popup').find('.team-desc').html('');
		$('.popup').find('.team-email').empty();
	});

	$('.team-block-col > a, .team-slider-js a').on('click', function (event) {
		event.preventDefault();

		var team_name = $(this).data('name');
		var team_jobtitle = $(this).data('jobtitle');
		var team_img = $(this).data('img');
		var team_desc = $(this).data('desc');
		var team_email = $(this).data('email');

		if ($(this).hasClass('active')) {
			$('.popup').removeClass('active');
			$('.team-block-col > a').removeClass('active');
			$('.popup').find('.team-name').html('');
			$('.popup').find('.team-jobtitle').html('');
			$('.popup').find('.team-img').css('background-image', '');
			$('.popup').find('.team-desc').html('');
			$('.popup').find('.team-email').empty();
		} else {
			$('.team-block-col > a').removeClass('active');
			$(this).addClass('active');
			$('.popup').addClass('active');
			if (team_name) {
				$('.popup').find('.team-name').html(team_name);
			}
			if (team_jobtitle) {
				$('.popup').find('.team-jobtitle').html(team_jobtitle);
			}
			if (team_img) {
				$('.popup').find('.team-img').css('background-image', 'url(' + team_img + ')');
			}
			if (team_desc) {
				$('.popup').find('.team-desc').html(team_desc);
			}

			if (team_email) {
				$('.popup').find('.team-email').html('<a href="mailto:' + team_email + '" class="btn btn-white">Email</a>');
			}


		}
	});

	const urlParams = new URLSearchParams(window.location.search);
	const searchquery = urlParams.get('searchquery');

	if (searchquery) {
		//const formattedQuery = searchquery.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

		// team
		const $teamBlockCol = $('.team-block-col');
		if ($teamBlockCol.length) {

			const $matchingAnchor = $teamBlockCol.find(`a[data-slug="${searchquery}"]`).first();

			if ($matchingAnchor.length) {
				const headerHeight = $('.header').outerHeight() || 0;
				const anchorTop = $matchingAnchor.offset().top - headerHeight;
				$('html, body').animate({ scrollTop: anchorTop }, 'slow');
				$matchingAnchor.trigger('click');
			}
		}

		const $softwarePanel = $('.software-panel .accordion-block');
		if ($softwarePanel.length) {

			const $matchingAnchor = $softwarePanel.find(`[data-name="${searchquery}"]`).first();

			if ($matchingAnchor.length) {

				const headerHeight = $('.header').outerHeight() || 0;
				const anchorTop = $matchingAnchor.offset().top - headerHeight;
				$('html, body').animate({ scrollTop: anchorTop }, 'slow');
				$matchingAnchor.trigger('click');
			}
		}
	}

});

$(window).scroll(function () {
	var scroll = $(window).scrollTop();
	if (scroll >= 50) {
		$(".header").addClass("sticky");
	} else {
		$(".header").removeClass("sticky");
	}
});
